// extracted by mini-css-extract-plugin
export default {"successMessage":"success-message-successMessage-b0dIjW"};